(function () {
  "use strict";

  if (window.__botaniqueCartCacheInstalled) return;
  window.__botaniqueCartCacheInstalled = true;

  var CACHE_TTL_MS = 1500;
  var cartCache = null;
  var cartInFlight = null;
  var kachingCartUpdateInFlight = new Map();
  var cacheVersion = 0;
  var nativeFetch = window.fetch.bind(window);

  function toUrl(input) {
    var value = typeof input === "string" ? input : input instanceof URL ? input.href : input && (input.url || input.href);
    if (!value) return null;

    try {
      return new URL(value, window.location.origin);
    } catch (_error) {
      return null;
    }
  }

  function requestMethod(input, init) {
    return String((init && init.method) || (input && input.method) || "GET").toUpperCase();
  }

  function isSameOrigin(url) {
    return url && url.origin === window.location.origin;
  }

  function isCartPath(pathname) {
    return /(^|\/)cart(?:[./]|$)/.test(pathname);
  }

  function isCartJsonRequest(method, url) {
    return method === "GET" && isSameOrigin(url) && /(^|\/)cart\.js$/.test(url.pathname);
  }

  function isCartMutationRequest(method, url) {
    return /^(POST|PUT|DELETE)$/.test(method) && isSameOrigin(url) && isCartPath(url.pathname);
  }

  function kachingCartUpdateDedupeKey(method, url, init) {
    if (method !== "POST" || !isSameOrigin(url) || !/(^|\/)cart\/update\.js$/.test(url.pathname)) return null;
    if (url.searchParams.get("kaching-cart") !== "true") return null;

    var body = init && init.body;
    if (body == null) body = "";
    if (typeof body !== "string") {
      if (body instanceof URLSearchParams) body = body.toString();
      else return null;
    }

    return url.pathname + url.search + "\n" + body;
  }

  function invalidate(reason) {
    cacheVersion += 1;
    cartCache = null;
    cartInFlight = null;
    window.dispatchEvent(
      new CustomEvent("botanique:cart-cache:invalidate", {
        detail: { reason: reason || "cart-mutation" },
      }),
    );
  }

  function snapshotHeaders(headers) {
    var entries = [];
    headers.forEach(function (value, key) {
      entries.push([key, value]);
    });
    return entries;
  }

  function responseFromSnapshot(snapshot) {
    return new Response(snapshot.body, {
      status: snapshot.status,
      statusText: snapshot.statusText,
      headers: snapshot.headers,
    });
  }

  function snapshotFromResponse(response) {
    return response.text().then(function (body) {
      return {
        body: body,
        headers: snapshotHeaders(response.headers),
        status: response.status,
        statusText: response.statusText,
        timestamp: Date.now(),
      };
    });
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (root) return new URL(root + "cart.js", window.location.origin).toString();

    var themeCartUrl = window.Theme && window.Theme.routes && window.Theme.routes.cart_url;
    return new URL((themeCartUrl || "/cart") + ".js", window.location.origin).toString();
  }

  function getCartResponse(input, init, options) {
    var force = Boolean(options && options.force);
    var now = Date.now();

    if (!force && cartCache && now - cartCache.timestamp < CACHE_TTL_MS) {
      return Promise.resolve(responseFromSnapshot(cartCache));
    }

    if (!force && cartInFlight) {
      return cartInFlight.then(responseFromSnapshot);
    }

    var requestVersion = cacheVersion;
    var inFlightPromise = nativeFetch(input || cartUrl(), init)
      .then(function (response) {
        return snapshotFromResponse(response).then(function (snapshot) {
          if (response.ok && requestVersion === cacheVersion) cartCache = snapshot;
          return snapshot;
        });
      })
      .finally(function () {
        if (cartInFlight === inFlightPromise) cartInFlight = null;
      });

    cartInFlight = inFlightPromise;
    return cartInFlight.then(responseFromSnapshot);
  }

  function getCart(options) {
    options = options || {};
    var force = Boolean(options.force);
    var now = Date.now();

    if (
      !force &&
      cartCache &&
      now - cartCache.timestamp < CACHE_TTL_MS
    ) {
      return getCartResponse(cartUrl(), { headers: { Accept: "application/json" } }, options).then(
        function (response) {
          return response.json();
        },
      );
    }

    if (!force && typeof options.kachingFallback === "function") {
      var snap = options.kachingFallback();
      if (snap && Array.isArray(snap.items) && snap.items.length > 0) {
        return Promise.resolve(snap);
      }
    }

    return getCartResponse(cartUrl(), { headers: { Accept: "application/json" } }, options).then(
      function (response) {
        return response.json();
      },
    );
  }

  window.fetch = function (input, init) {
    var url = toUrl(input);
    var method = requestMethod(input, init);

    if (isCartMutationRequest(method, url)) {
      var dedupeKey = kachingCartUpdateDedupeKey(method, url, init);
      if (dedupeKey) {
        var inFlight = kachingCartUpdateInFlight.get(dedupeKey);
        if (inFlight) return inFlight.then(function (entry) { return responseFromSnapshot(entry.snapshot); });

        inFlight = nativeFetch(input, init)
          .then(function (response) {
            invalidate(method + " " + url.pathname);
            return snapshotFromResponse(response.clone()).then(function (snapshot) {
              return { response: response, snapshot: snapshot };
            });
          })
          .finally(function () {
            kachingCartUpdateInFlight.delete(dedupeKey);
          });

        kachingCartUpdateInFlight.set(dedupeKey, inFlight);
        return inFlight.then(function (entry) { return entry.response; });
      }

      return nativeFetch(input, init).then(function (response) {
        invalidate(method + " " + url.pathname);
        return response;
      });
    }

    if (isCartJsonRequest(method, url)) {
      return getCartResponse(typeof input === "string" ? url.toString() : input, init);
    }

    return nativeFetch(input, init);
  };

  (function wrapXhr() {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__botaniqueCartRequest = { method: String(method || "GET").toUpperCase(), url: url };
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var request = this.__botaniqueCartRequest;
      var url = request && toUrl(request.url);
      if (request && isCartMutationRequest(request.method, url)) {
        this.addEventListener(
          "load",
          function () {
            invalidate(request.method + " " + url.pathname);
          },
          { once: true },
        );
      }
      return originalSend.apply(this, arguments);
    };
  })();

  function installJqueryTransport() {
    if (window.__botaniqueCartCacheJqueryInstalled) return true;
    if (!window.jQuery || !window.jQuery.ajaxTransport) return false;

    window.__botaniqueCartCacheJqueryInstalled = true;
    window.jQuery.ajaxTransport("+*", function (options) {
      var method = String(options.type || options.method || "GET").toUpperCase();
      var url = toUrl(options.url);
      if (!isCartJsonRequest(method, url)) return undefined;

      var aborted = false;
      return {
        send: function (_headers, complete) {
          getCartResponse(url.toString(), { headers: { Accept: "application/json" } })
            .then(function (response) {
              return response.text().then(function (text) {
                if (aborted) return;

                var responseHeaders = [];
                response.headers.forEach(function (value, key) {
                  responseHeaders.push(key + ": " + value);
                });
                complete(response.status, response.statusText || "OK", { text: text }, responseHeaders.join("\r\n"));
              });
            })
            .catch(function () {
              if (!aborted) complete(0, "error");
            });
        },
        abort: function () {
          aborted = true;
        },
      };
    });

    return true;
  }

  if (!installJqueryTransport()) {
    var attempts = 0;
    var jqueryTimer = window.setInterval(function () {
      attempts += 1;
      if (installJqueryTransport() || attempts > 200) {
        window.clearInterval(jqueryTimer);
      }
    }, 50);
  }

  window.BotaniqueCartCache = {
    getCart: getCart,
    invalidate: invalidate,
    _getCartResponse: getCartResponse,
    _isCartJsonRequest: isCartJsonRequest,
    _isCartMutationRequest: isCartMutationRequest,
  };
})();
